<template>
  <!-- eslint-disable vue/require-component-is -->
  <template v-if="isLink">
    <a :class="css" :aria-label="ariaLabel" href="#" @click.prevent="citiRedirect()"><slot name="citi-link-content"></slot></a>
  </template>
  <template v-else>
    <button :class="css" :aria-label="ariaLabel" @click="citiRedirect()">
      <slot name="citi-link-content"></slot>
    </button>
  </template>
  <component :is="citiForm" v-if="citiForm" />
</template>

<script setup>
/* istanbul ignore file */
import { ref, defineAsyncComponent, markRaw } from 'vue';
import { storeToRefs } from 'pinia';
import { Cookie } from '@vue-util/cookie';
import { fireTag } from '@vue-util/tagManager';
import { onlineGuid, onlineUid } from 'config';
import { useCitiRedirectStore } from '@/stores/useCitiRedirectStore';
import { useWalletStore } from '@/stores/useWalletStore';
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';

// this component is used for all citi redirect functionality
// defaults to a link, with no card id, css or action without props passed
// visit this link to see action required for specific link: https://confluence.federated.fds/pages/viewpage.action?spaceKey=CSTMGMT&title=Credit+Migration+ShopApp+to+xAPI
// example action 'dashboard' for credit summary link /account-xapi/api/creditservice/creditdeeplink

const props = defineProps({
  ariaLabel: {
    type: String,
  },
  isLink: {
    type: Boolean,
    default: true,
  },
  cardId: {
    type: String,
    default: '',
  },
  css: {
    type: Array,
    default: () => [],
  },
  action: {
    type: String,
    default: '',
  },
  fireTagLink: {
    type: String,
    default: '',
  },
  persistentLoginObj: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['callingStepUpOverlay']);

const citiRedirectStore = useCitiRedirectStore();
const walletStore = useWalletStore();
const envPropsStore = useEnvPropsStore();

const citiForm = ref(null);

const { extendToken } = storeToRefs(walletStore);

const citiRedirect = async (callbackFunction) => {
  if (!extendToken.value) {
    fireTag('link', {
      event_name: 'make a payment',
      link_name: 'make a payment',
    });
  }
  if (props.persistentLoginObj.persistentLoginEnabled && extendToken.value && !callbackFunction) {
    emit('callingStepUpOverlay', citiRedirect);
    fireTag('view', {
      page_type: 'step up login',
      page_name: 'home credit card make a payment',
      link_name: 'make a payment',
    });
    return;
  }
  if (callbackFunction) {
    walletStore.setExtendToken(false);
  }
  fireTag('link', {
    event_name: 'my account credit links',
    link_name: props.fireTagLink,
  });

  const userId = Cookie.get(onlineUid);
  const userGuid = Cookie.get(onlineGuid);
  const secureUserToken = Cookie.get('secure_user_token');

  if (props.action === 'applynow') {
    await citiRedirectStore.fetchApplyNowUrl({
      deviceType: envPropsStore.deviceType,
    });
  } else {
    await citiRedirectStore.fetchCitiUrl({
      userId,
      userGuid,
      secureUserToken,
      cardId: props.cardId,
      deviceType: envPropsStore.deviceType,
      action: props.action,
    });
  }
  citiForm.value = markRaw(defineAsyncComponent(() => import('./CitiForm')));
};
</script>
